import { render } from "./p-filter-select.vue?vue&type=template&id=5bc281f9&scoped=true"
import script from "./p-filter-select.vue?vue&type=script&lang=js"
export * from "./p-filter-select.vue?vue&type=script&lang=js"

import "./p-filter-select.vue?vue&type=style&index=0&id=5bc281f9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc281f9"]])

export default __exports__